import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Table } from 'components/Page';
import config from './config';

const ActivityTemplates = ({ objectId }) => (
  // Read Only Table
  <Table
    canAdmin={false}
    reducer={{
      list: REDUCER_KEY.assignedActivityTemplates,
      item: REDUCER_KEY.template
    }}
    objectId={objectId} // the parent object
    config={{
      ...config,
      filters: {
        activities__id: [objectId]
      }
    }}
  />
);

ActivityTemplates.propTypes = {
  objectId: PropTypes.number
};

ActivityTemplates.defaultProps = {
  objectId: null
};

export default ActivityTemplates;
